// const currencyCountryMap = {
//   AED: "ae",
//   AFA: "af",
//   AOA: "ao",
//   ARS: "ar",
//   AUD: "au",
//   AWG: "aw",
//   BGN: "bg",
//   BHD: "bh",
//   BIF: "bi",
//   BND: "bn",
//   BOB: "bo",
//   BRL: "br",
//   BZD: "bz",
//   CAD: "ca",
//   CHF: "ch",
//   CNY: "cn",
//   COP: "co",
//   CUP: "cu",
//   CUC: "cu",
//   CZK: "cz",
//   DKK: "dk",
//   DZD: "dz",
//   EGP: "eg",
//   EUR: "eu",
//   FJD: "fj",
//   FKP: "fk",
//   FR: "fr",
//   GBP: "gb",
//   GHS: "gh",
//   GMD: "gm",
//   GTQ: "gt",
//   HNL: "hn",
//   HRK: "hr",
//   HUF: "hu",
//   IDR: "id",
//   INR: "in",
//   ISK: "is",
//   JOD: "jo",
//   JPY: "jp",
//   KES: "ke",
//   KGS: "kg",
//   KHR: "kh",
//   KWD: "kw",
//   KZT: "kz",
//   LAK: "la",
//   LBP: "lb",
//   LKR: "lk",
//   MAD: "ma",
//   MKD: "mk",
//   MNT: "mn",
//   MUR: "mu",
//   MXN: "mx",
//   MWK: "mw",
//   MYR: "my",
//   NGN: "ng",
//   NIO: "ni",
//   NOK: "no",
//   NPR: "np",
//   NZD: "nz",
//   OMR: "om",
//   PEN: "pe",
//   PHP: "ph",
//   PKR: "pk",
//   PLN: "pl",
//   QAR: "qa",
//   RON: "ro",
//   RUB: "ru",
//   RWF: "rw",
//   SAR: "sa",
//   SCR: "sc",
//   SEK: "se",
//   SGD: "sg",
//   SLL: "sl",
//   SN: "xof", // originally XOF
//   SY: "syp", // originally SYP
//   THB: "th",
//   TJS: "tj",
//   TMT: "tm",
//   TND: "tn",
//   TRY: "tr",
//   TWD: "tw",
//   TZS: "tz",
//   UAH: "ua",
//   USD: "us",
//   VEF: "ve",
//   VND: "vn",
//   XOF: "sn",
//   XPF: "fr",
//   ZAR: "za",
//   ZMK: "zm",
//   ZMW: "zm",
//   ZWD: "zw",
// };

// export default currencyCountryMap;

// const currencyCountryMap = {
//   USD: "us",    // USA
//   ZAR: "za",    // South Africa
//   NGN: "ng",    // Nigeria
//   GBP: "gb",    // United Kingdom
//   CAD: "ca",    // Canada
//   GHS: "gh",    // Ghana
//   KES: "ke",    // Kenya
//   // CNY: "cn",    // China
//   INR: "in",    // India
//   PHP: "ph",    // Philippines
//   PKR: "pk",    // Pakistan
//   SEK: "se",    // Sweden
//   // CHF: "ch",    // Switzerland
//   EUR: "eu"
// };

const currencyCountryMap = {
  UGX: "ug",   // Uganda
  TZS: "tz",   // Tanzania
  NGN: "ng",   // Nigeria
  MWK: "mw",   // Malawi
  KES: "ke",   // Kenya
  BRL: "br"    // Brazil
};


export default currencyCountryMap;
